import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "ps-panel" }
const _hoisted_2 = { class: "tz-option-body" }
const _hoisted_3 = { class: "tz-option-desc" }
const _hoisted_4 = {
  key: 0,
  class: "tz-clock"
}
const _hoisted_5 = {
  key: 0,
  class: "tz-clock"
}
const _hoisted_6 = {
  key: 0,
  class: "tz-manual-area"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "tz-saved"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "ps-panel-hd" }, [
      _createElementVNode("h2", null, "Fuso Horário"),
      _createElementVNode("p", null, "Define como os horários são exibidos para você. Não altera os horários da obra — apenas a exibição.")
    ], -1)),
    _createElementVNode("button", {
      class: _normalizeClass(["tz-option", { 'tz-option--active': _ctx.mode === 'auto' }]),
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.chooseAuto && _ctx.chooseAuto(...args)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["tz-radio", { checked: _ctx.mode === 'auto' }])
      }, null, 2),
      _createElementVNode("span", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "tz-option-title" }, "Automático", -1)),
        _createElementVNode("span", _hoisted_3, [
          (_ctx.ipTz)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[4] || (_cache[4] = _createTextVNode("Detectado pela sua localização (IP): ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.ipTz), 1)
              ], 64))
            : (_ctx.ipChecked)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[5] || (_cache[5] = _createTextVNode("Não foi possível detectar pelo IP — usando o fuso do dispositivo: ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.browserTz), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode("Detectando pela sua localização…")
                ], 64))
        ])
      ]),
      (_ctx.mode === 'auto')
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.nowPreview), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["tz-option tz-option--stack", { 'tz-option--active': _ctx.mode === 'manual' }])
    }, [
      _createElementVNode("button", {
        class: "tz-option-head",
        type: "button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.chooseManualMode && _ctx.chooseManualMode(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["tz-radio", { checked: _ctx.mode === 'manual' }])
        }, null, 2),
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "tz-option-body" }, [
          _createElementVNode("span", { class: "tz-option-title" }, "Selecionar manualmente"),
          _createElementVNode("span", { class: "tz-option-desc" }, "Escolha um fuso fixo, independente de onde você estiver.")
        ], -1)),
        (_ctx.mode === 'manual')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.nowPreview), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.mode === 'manual')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter) = $event)),
              class: "tz-filter",
              type: "text",
              placeholder: "Buscar fuso (ex: New_York, Lisbon, Sao_Paulo)..."
            }, null, 512), [
              [_vModelText, _ctx.filter]
            ]),
            _createElementVNode("select", {
              class: "tz-select",
              value: _ctx.manualTz,
              size: "8",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSelectTz($event)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredZones, (tz) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: tz,
                  value: tz
                }, _toDisplayString(tz) + " (" + _toDisplayString(_ctx.offsetOf(tz)) + ") ", 9, _hoisted_8))
              }), 128))
            ], 40, _hoisted_7)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.savedMsg)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.savedMsg), 1))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "tz-note" }, "O horário atual no fuso selecionado aparece ao lado da opção ativa. A preferência fica salva na sua conta.", -1))
  ]))
}